<template>
  <div class="inline-block pb-[56.25%] relative h-0 w-full">
    <iframe class="h-full absolute w-full"
      :src="url" 
      :title="title"
      :allow="allow"
      :referrerpolicy="referrerpolicy"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { buildShareUrls } from '~~/shared/utils/share.config'

interface YouTubeProps {
  videoId?: string
  title?: string
  allow?: string
  referrerpolicy?: 'no-referrer' | 'no-referrer-when-downgrade' | 'origin' | 'origin-when-cross-origin' | 'same-origin' | 'strict-origin' | 'strict-origin-when-cross-origin' | 'unsafe-url'
}

const props = withDefaults(defineProps<YouTubeProps>(), {
  title: 'YouTube video player',
  allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
  referrerpolicy: 'strict-origin-when-cross-origin'
})

const url = computed(() => {
  return props.videoId
    ? buildShareUrls.youtubeEmbed(props.videoId)
    : ''
})
</script>
